import axios, { AxiosInstance } from 'axios';

export class BaseAuthService {
    axiosClient: AxiosInstance;
    baseAPI: string

    constructor() {
        this.initializeConfig();
        this.axiosClient = axios.create({
            baseURL: `${process.env.REACT_APP_SERVER_USERS}`
        });
        this.initAxiosInterceptor();
    }

    private initializeConfig() {
        this.configAxios();
    }

    configAxios() {
        this.axiosClient = axios.create({
            baseURL: this.baseAPI,
        });
    }

    initAxiosInterceptor() {
        this.axiosClient.interceptors.request.use((config) => {
            if(config.url !== '/login') {
                const token = localStorage.getItem('token');
                if (token) {
                    config.headers.Authorization = `${token}`;
                }
            }
            return config;
        });
    }
}

